import React, { Component } from 'react';
import { I18n } from 'react-i18next';

export default class Section10 extends Component {
    render () {
        return (
            <I18n>
                {
                    (t, { i18n }) => (
                        <div className="section" id="section10">
                            <div className="s10-bg">
                                <div className="container">
                                    <div className="row">
                                        <h2>Triam network advantages</h2>
                                        <p className="s10-info">{t('home_66')}</p>
                                        <p className="text-center wow shake">
                                            <a className="btn btn-download" target="_blank" rel="noopener noreferrer" href="/documents/TRIAM.pdf">
                                                {t('home_67')}
                                            </a>
                                        </p>
                                        <p className="s10-blockchain">{t('home_68')}</p>
                                        <div className="table-responsive">
                                            <table className="table table-hover">
                                                <tbody>
                                                <tr>
                                                    <td>{t('home_72')}</td>
                                                    <td>{t('home_69')}</td>
                                                    <td>{t('home_70')}</td>
                                                    <td>{t('home_71')}</td>
                                                </tr>
                                                <tr>
                                                    <td>Bitcoin</td>
                                                    <td>{t('home_73')}</td>
                                                    <td>{t('home_77')}</td>
                                                    <td>{t('home_80')}</td>
                                                </tr>
                                                <tr>
                                                    <td>Ethereum</td>
                                                    <td>{t('home_74')}</td>
                                                    <td>{t('home_78')}</td>
                                                    <td>{t('home_80')}</td>
                                                </tr>
                                                <tr>
                                                    <td>EOS</td>
                                                    <td>{t('home_75')}</td>
                                                    <td>{t('home_79')}</td>
                                                    <td>{t('home_81')}</td>
                                                </tr>
                                                <tr>
                                                    <td>RIA</td>
                                                    <td>{t('home_76')}</td>
                                                    <td>{t('home_79')}</td>
                                                    <td>{t('home_80')}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </I18n>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/section10.jsx